import { LoggedInUserResponseModel } from "../service/model/logged-in-user-response.model";
import { UserType } from "../shared/enums";

export const isOwner = (loggedInUser?: LoggedInUserResponseModel): boolean => {
    if (!loggedInUser) {
        return false;
    }
    return loggedInUser?.roleData?.businessUser?.role?.name === 'ROLE_OWNER';
}

export const isAdmin = (loggedInUser?: LoggedInUserResponseModel): boolean => {
    if (!loggedInUser) {
        return false;
    }
    return loggedInUser?.type === UserType.GYMINIFY;
}

export const isMember = (loggedInUser?: LoggedInUserResponseModel): boolean => {
    if (!loggedInUser) {
        return false;
    }
    return loggedInUser?.type === UserType.MEMBER;
}
